import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/pro-light-svg-icons';

const PlayIcon = ({ className = '', ...rest }) => {
  return <FontAwesomeIcon icon={faPlay} {...rest} className={className} />;
};

export default PlayIcon;
